<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card class="md-card-plain">
          <md-card-header>
            <h4 class="title"><b>Mayai</b></h4>
            <p class="tim-note">List of customers</p>
          </md-card-header>
          <md-card-content>
            <template>
              <div>
                <h5>
                  <span class="tim-note">Active Customers # </span>{{ active }}
                </h5>
                <h5>
                  <span class="tim-note">In-active Customers # </span
                  >{{ inactive }}
                </h5>
              </div>
              <!-- <div>
                <md-table
                  v-model="companies"
                  :table-header-color="tableHeaderColor"
                  md-fixed-header
                >
                  <md-table-row slot="md-table-row" slot-scope="{ item, index }">
                    <md-table-cell md-label="ID">{{ index+1 }}</md-table-cell>
                    <md-table-cell md-label="Name" >{{ item.name.substring(0,10) }}</md-table-cell>
                    <md-table-cell md-label="Status"  > 
                      {{ item.status === 'inactive' ? "Sleep" : (item.status === 'cancelled' ? "Cancel" : item.status) }} 
                    </md-table-cell>
                    <md-table-cell md-label="Plan">{{ item.pricing_plan }}</md-table-cell>
                    <md-table-cell md-label="No Of Calls" >{{ item.call_data  ? item.call_data.in_calls : 0 }}</md-table-cell>
                    <md-table-cell md-label="Credit Card Registered" >{{ item.payment_method === 1  ? "Yes" : "No" }}</md-table-cell>
                    <md-table-cell md-label="Email">{{ item.email }}</md-table-cell> 
                  </md-table-row>
                </md-table>
              </div> -->
              <div>
                <vue-table-dynamic
                  :params="params"
                  ref="table"
                ></vue-table-dynamic>
              </div>
            </template>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
// import { SimpleTable} from "@/components";
import ApiService from "@/services/ApiService";
import VueTableDynamic from "vue-table-dynamic";

export default {
  components: { VueTableDynamic },
  props: {
    tableHeaderColor: {
      type: String,
      default: "green"
    }
  },
  data() {
    return {
      companies: [],
      active: 0,
      inactive: 0,
      params: {
        data: [],
        sort: [0, 1, 3, 4],
        header: "row",
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: 350 },
          { column: 1, width: 100 },
          { column: 2, width: 200 },
          { column: 3, width: 150 }
        ],
        height: 500,
        fixed: 0,
        pagination: true,
        pageSize: 20,
        pageSizes: [10, 20, 30, 40, 50]
      }
    };
  },
  mounted() {
    this.fetchCustomer();
  },
  methods: {
    async fetchCustomer() {
      var responce = await ApiService.fetchMayaiCustomers();
      // console.log(responce);
      this.active = 0;
      if (responce.data) {
        this.companies = responce.data.customers;
        this.params.data = [];
        this.params.data.push([
          "Name",
          "Status",
          "Plan",
          "No Of Calls",
          "Current Charge",
          "Registered Credit Card"
        ]);
        await this.companies.forEach(async comp => {
          // console.log(comp.name);
          // console.log(comp.total_billable);
          // console.log(comp.pricing_plan);
          var status = comp.status;

          if (comp.status === "active") {
            this.active++;
            status = "Active";
          } else if (comp.status === "inactive") {
            this.inactive++;
            status = "Sleep";
          } else if (comp.status === "cancelled") {
            status = "Cancel";
          }
          this.params.data.push([
            comp.name,
            status,
            comp.pricing_plan,
            comp.call_data ? comp.call_data.in_calls : 0,
            comp.total_billable,
            comp.payment_method == 1 ? "Yes" : "No"
          ]);
        });
      }
    }
  }
};
</script>
//
<style lang="scss">
// .md-table.mayai-list .md-table-head {
//     text-align: center;
// }
//
</style>
